<ion-content>
  <app-media-messages-list></app-media-messages-list>
</ion-content>
